import React, { useState } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import { useHistory } from "react-router";
import httpService from "../../../services/httpServices/httpServices";
import validateFormNotificationTicket from "../../../validtions/forms/ticket/add-notification";
import helperSpinner from "../../../helpers/spinner";

function AddNotificationTicket() {
  const [message, setMessage] = useState();
  const history = useHistory();

  let messageTag;

  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }
  const sendForm = async (event) => {
    event.preventDefault();
    const data = getDataForm();

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (await sendRequsetAddNotificationTicket(data)) {
      history.push("/ticket/all-notification");
      return;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const sendRequsetAddNotificationTicket = async (data) => {
    const headersRequest = getHeaderForRequset();

    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/ticket/notification",
        data,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const getDataForm = () => {
    const name = document.getElementById("name").value;
    const mobile = document.getElementById("mobile").value;
    const data = {
      name: name,
      mobile: mobile,
    };

    if (validateFormNotificationTicket(data) != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: validateFormNotificationTicket(data),
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }
    return data;
  };

  const getHeaderForRequset = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  return (
    <>
      <Sidebar openItem="tickets" />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">اطلاع رسانی جدید</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body" id="add-ticket">
              {messageTag}
              <form encType="multipart/form-data" onSubmit={sendForm}>
                <div className="form-group">
                  <label>نام</label>
                  <input type="text" className="form-control" id="name" />
                </div>

                <div className="form-group">
                  <label>شماره موبایل</label>
                  <input
                    type="number"
                    placeholder="09129245508"
                    className="form-control"
                    id="mobile"
                  />
                </div>

                <button type="submit" className="btn btn-outline-primary">
                  ارسال
                </button>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AddNotificationTicket;
